import { isValidDate } from '../create/create-ts-date';
import { absFloor } from '../utils/utils';
export var diffCalendarYear = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return d1.getFullYear() - d2.getFullYear();
};
export var diffCalendarMonth = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getFullYear() - d2.getFullYear()) * 12 + d1.getMonth() - d2.getMonth();
};
export var diffCalendarDate = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var u1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var u2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return absFloor((u1 - u2) / 86400000 /* Date */);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/diff/diff-calendar-unit.js
// module id = null
// module chunks = 